//TODO: this should be in sync with electron version
import { type EventType, type TelemetryAdapter, type TelemetryMetadata, type CustomDimensions } from '@/features/telemetry/types'

export function useConsoleTelemetryAdapter(initialMetadata: TelemetryMetadata): TelemetryAdapter {
	let metadata: TelemetryMetadata = initialMetadata

	const isEnabled = import.meta.env.DEV

	return {
		trackEvent(type: EventType, name: string, customProperties?: CustomDimensions) {
			if (!isEnabled) {
				return
			}

			console.info('[EVENT]', name, type, customProperties, {
				app_version: metadata.app?.version,
				user_id: metadata.user?.id ? String(metadata.user.id) : undefined,
				device_id: metadata.app?.installationId
			})
		},

		trackException(exception: Error, message: string, customProperties?: CustomDimensions) {
			if (!isEnabled) {
				return
			}

			console.error('[EXCEPTION]', message, exception, customProperties)
		},

		trackPageView(name: string, uri: string) {
			if (!isEnabled) {
				return
			}

			console.info('[PAGE]', name, uri)
		},

		setMetadata(telemetryMetadata: TelemetryMetadata) {
			metadata = telemetryMetadata
		},

		startTransaction() {
			// Not used in console adapter
			return undefined
		}
	}
}
